"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProxy = setProxy;
exports.enable = enable;
exports.reload = reload;
exports.navigate = navigate;
exports.getNavigationHistory = getNavigationHistory;
exports.getAppManifest = getAppManifest;
exports.getResourceTree = getResourceTree;
exports.getResourceContent = getResourceContent;
exports.screencastFrameAck = screencastFrameAck;
exports.startScreencast = startScreencast;
exports.stopScreencast = stopScreencast;
var _1 = __importDefault(require("licia/$"));
var contain_1 = __importDefault(require("licia/contain"));
var fetch_1 = __importDefault(require("licia/fetch"));
var now_1 = __importDefault(require("licia/now"));
var Readiness_1 = __importDefault(require("licia/Readiness"));
var map_1 = __importDefault(require("licia/map"));
var request_1 = require("../lib/request");
var constants_1 = require("../lib/constants");
var util_1 = require("../lib/util");
var connector_1 = __importDefault(require("../lib/connector"));
var nodeManager_1 = require("../lib/nodeManager");
var html2canvas_1 = __importDefault(require("html2canvas"));
var resources = __importStar(require("../lib/resources"));
var proxy = '';
function setProxy(params) {
    proxy = params.proxy;
}
function enable() {
    stopScreencast();
}
function reload() {
    location.reload();
}
function navigate(params) {
    location.href = params.url;
    return {
        frameId: constants_1.MAIN_FRAME_ID,
    };
}
function getNavigationHistory() {
    return {
        currentIndex: 0,
        entries: [
            {
                id: 0,
                url: (0, util_1.getUrl)(),
                userTypedURL: (0, util_1.getUrl)(),
                title: document.title,
                transitionType: 'link',
            },
        ],
    };
}
function getAppManifest() {
    return __awaiter(this, void 0, void 0, function () {
        var $links, ret, url, res, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    $links = (0, _1.default)('link');
                    ret = {
                        errors: [],
                    };
                    url = '';
                    $links.each(function () {
                        var $this = (0, _1.default)(this);
                        if ($this.attr('rel') === 'manifest') {
                            url = (0, request_1.fullUrl)($this.attr('href'));
                        }
                    });
                    ret.url = url;
                    if (!url) return [3, 3];
                    return [4, (0, fetch_1.default)(url)];
                case 1:
                    res = _b.sent();
                    _a = ret;
                    return [4, res.text()];
                case 2:
                    _a.data = _b.sent();
                    _b.label = 3;
                case 3: return [2, ret];
            }
        });
    });
}
function getResourceTree() {
    var images = (0, map_1.default)(resources.getImages(), function (url) {
        var mimeType = 'image/jpg';
        if ((0, contain_1.default)(url, 'png')) {
            mimeType = 'image/png';
        }
        else if ((0, contain_1.default)(url, 'gif')) {
            mimeType = 'image/gif';
        }
        return {
            url: url,
            mimeType: mimeType,
            type: 'Image',
        };
    });
    return {
        frameTree: {
            frame: {
                id: constants_1.MAIN_FRAME_ID,
                mimeType: 'text/html',
                securityOrigin: (0, util_1.getOrigin)(),
                url: (0, util_1.getUrl)(),
            },
            resources: __spreadArray([], images, true),
        },
    };
}
function getResourceContent(params) {
    return __awaiter(this, void 0, void 0, function () {
        var frameId, url, base64Encoded, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    frameId = params.frameId, url = params.url;
                    base64Encoded = false;
                    if (!(frameId === constants_1.MAIN_FRAME_ID)) return [3, 5];
                    content = '';
                    if (!(url === location.href)) return [3, 2];
                    return [4, (0, util_1.getTextContent)(url)];
                case 1:
                    content = _a.sent();
                    if (!content) {
                        content = document.documentElement.outerHTML;
                    }
                    return [3, 4];
                case 2:
                    if (!resources.isImage(url)) return [3, 4];
                    return [4, (0, util_1.getBase64Content)(url, proxy)];
                case 3:
                    content = _a.sent();
                    base64Encoded = true;
                    _a.label = 4;
                case 4: return [2, {
                        base64Encoded: base64Encoded,
                        content: content,
                    }];
                case 5: return [2, {
                        base64Encoded: base64Encoded,
                        content: '',
                    }];
            }
        });
    });
}
var screenshotTimer;
var ack;
var screencastInterval = 2000;
var isCapturingScreenshot = false;
function screencastFrameAck() {
    if (ack) {
        ack.signal('ack');
    }
}
function startScreencast() {
    if (isCapturingScreenshot) {
        return;
    }
    stopScreencast();
    captureScreenshot();
}
function stopScreencast() {
    if (screenshotTimer) {
        clearTimeout(screenshotTimer);
        screenshotTimer = null;
        if (ack) {
            ack.signal('ack');
        }
    }
}
function captureScreenshot() {
    return __awaiter(this, void 0, void 0, function () {
        var $body, deviceWidth, deviceHeight, offsetTop, overflowY, width, options, time, canvas, duration, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (document.hidden) {
                        screenshotTimer = setTimeout(captureScreenshot, screencastInterval);
                        return [2];
                    }
                    isCapturingScreenshot = true;
                    $body = (0, _1.default)(document.body);
                    deviceWidth = window.innerWidth;
                    deviceHeight = window.innerHeight;
                    offsetTop = -window.scrollY;
                    overflowY = $body.css('overflow-y');
                    if ((0, contain_1.default)(['auto', 'scroll'], overflowY)) {
                        deviceHeight = $body.offset().height;
                        offsetTop = -document.body.scrollTop;
                    }
                    width = $body.offset().width;
                    if (width < deviceWidth) {
                        width = deviceWidth;
                    }
                    options = {
                        imageTimeout: 5000,
                        scale: 1,
                        width: width,
                        logging: false,
                        ignoreElements: function (node) {
                            return !(0, nodeManager_1.isValidNode)(node);
                        },
                    };
                    if (proxy) {
                        options.proxy = proxy;
                    }
                    else {
                        options.foreignObjectRendering = true;
                        options.useCORS = true;
                    }
                    time = (0, now_1.default)();
                    return [4, (0, html2canvas_1.default)(document.body, options)];
                case 1:
                    canvas = _a.sent();
                    duration = (0, now_1.default)() - time;
                    screencastInterval = 2000;
                    if (duration * 5 > screencastInterval) {
                        screencastInterval = duration * 5;
                    }
                    data = canvas
                        .toDataURL('image/jpeg')
                        .replace(/^data:image\/jpeg;base64,/, '');
                    if (!ack) return [3, 3];
                    return [4, ack.ready('ack')];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    ack = new Readiness_1.default();
                    connector_1.default.trigger('Page.screencastFrame', {
                        data: data,
                        sessionId: 1,
                        metadata: {
                            deviceWidth: deviceWidth,
                            deviceHeight: deviceHeight,
                            pageScaleFactor: 1,
                            offsetTop: offsetTop,
                            scrollOffsetX: 0,
                            scrollOffsetY: 0,
                            timestamp: (0, now_1.default)(),
                        },
                    });
                    screenshotTimer = setTimeout(captureScreenshot, screencastInterval);
                    isCapturingScreenshot = false;
                    return [2];
            }
        });
    });
}
